import classes from "./setting.module.css";
import { useNavigate } from "react-router-dom";
import svgBack from "../../assets/SVGs/back.svg";
import checkToken from "../../functions/checkToken";
import refreshToken from "../../functions/refreshToken";
import toast from "react-hot-toast";

function Setting() {
  function signOut() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("refresh_token", localStorage.getItem("refresh_token"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_API_URL}/api/v1/user/logout`, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          // If the response status is 200, clear localStorage and navigate to login
          localStorage.clear();
          navigator("/login");
        } else {
          toast.error("خطا در خروج رخ داده است دوباره امتحان کنید");
        }
        return response.text(); // Optionally return the text for debugging
      })
      .then((result) => console.log(result))
      .catch((error) =>
        toast.error("خطا در خروج رخ داده است دوباره امتحان کنید")
      );
  }

  const navigator = useNavigate();
  const username = localStorage.getItem("username");
  const phone = localStorage.getItem("phone");

  checkToken();
  refreshToken();

  return (
    <div className={classes.main}>
      <div className={classes.header}>
        <div className={classes.return} onClick={() => navigator(-1)}>
          <img src={svgBack} className={classes.svg} />
        </div>
      </div>
      <div className={classes.container}>
        <div className={classes.info_card}>
          <div className={classes.key_text}>نام کاربری</div>
          <div className={classes.key_text}>شماره تلفن</div>
          <div className={classes.value_text}>
            {" "}
            {username !== "undefined" ? username : "-"}
          </div>
          <div className={classes.value_text}>{phone || "-"}</div>
        </div>
        <div className={classes.buttonContainer}>
          <input
            className={classes.button}
            type="button"
            value="تغییر رمز عبور"
            onClick={() => navigator("/reset_password")}
          />
          {/* <input
            className={classes.button}
            type="button"
            value="خروج از حساب کاربری"
            onClick={() => signOut()}
          /> */}
        </div>
      </div>
    </div>
  );
}

export default Setting;
